import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ActionButton } from 'core/components';
import { ActionButtonType } from 'core/enums';
import { useNotificationContext } from 'core/states';
import { QuoteEntityType, QuoteType } from 'quotes/enums';
import { IQuotePart, IVendorQuote } from 'quotes/types';
import { Color, Variant } from 'theme/enums';

import { QuotePartAddToQuote } from './QuotePartAddToQuote';

interface IProps {
  quote: IVendorQuote;
  quoteParts: IQuotePart[];
  onSubmitSuccess?: () => void;
  entityType?: QuoteEntityType;
}

export const QuotePartAddToQuoteButton = ({
  quote,
  quoteParts,
  onSubmitSuccess,
  entityType = QuoteEntityType.QUOTE,
}: IProps) => {
  const [addToQuoteType, setAddToQuoteType] = useState<QuoteType | null>(null);

  const { t } = useTranslation();

  const { isLoadingTopNotificationDisplayed } = useNotificationContext();

  const isDisabled = useMemo(
    () => isLoadingTopNotificationDisplayed,
    [isLoadingTopNotificationDisplayed]
  );

  const handleClose = () => setAddToQuoteType(null);

  return (
    <>
      <ActionButton
        action={{
          type: ActionButtonType.MENU,
          label: t('buttonLabelAddToQuote', { entityType }),
          color: Color.NEUTRAL,
          variant: Variant.OUTLINED,
          menuItems: [
            {
              label: t('buttonLabelAddToCustomerQuote', { entityType }),
              onClick: () => setAddToQuoteType(QuoteType.CUSTOMER),
            },
            {
              label: t('buttonLabelAddToVendorQuote', { entityType }),
              onClick: () => setAddToQuoteType(QuoteType.VENDOR),
            },
          ],
          disabled: isDisabled,
        }}
      />

      {!isDisabled && (
        <QuotePartAddToQuote
          addToQuoteType={addToQuoteType}
          onClose={handleClose}
          quote={quote}
          quoteParts={quoteParts}
          onSubmitSuccess={onSubmitSuccess}
          entityType={entityType}
        />
      )}
    </>
  );
};
